const MasterDataFileEndpoint = {
  SAVE_FILES: '/cmms/master-data/save-files',
  SAVE_SITE_FILES: '/cmms/master-data/save-site-files',
  CHANGE_DETAILS: '/cmms/master-data/change-details',
  CHANGE_SITE_DETAILS: '/cmms/master-data/change-site-details',
  REMOVE_FILE: '/cmms/master-data/remove-file',
  REMOVE_SITE_FILE: '/cmms/master-data/remove-site-file',
  GET_CONTENT: '/cmms/master-data/get-content',
  GET_SITE_CONTENT: '/cmms/master-data/get-site-content',
  GET_FILES: '/cmms/master-data/get-files',
  GET_SITE_FILES: '/cmms/master-data/get-site-files',
};

export default MasterDataFileEndpoint;
